<template>
  <a-modal :title="title"
           :width="800"
           :visible="visible"
           @ok="onSave"
           @cancel="onCancel"
           :confirmLoading="confirmLoading">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item v-if="parent"
                   label='所属上级'
                   :labelCol="{ span: 5 }"
                   :wrapperCol="{ span: 12 }">
        {{ parent.name }}
      </a-form-model-item>
      <a-form-model-item
          label='字典项名称'
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 12 }" prop="name">
        <a-input v-model="form.name" placeholder='字典项名称'/>
      </a-form-model-item>
      <a-form-model-item
          label='字典项取值'
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 12 }" prop="value">
        <a-input v-model="form.value" placeholder='字典项取值'/>
      </a-form-model-item>
      <a-form-model-item
          label='顺序号'
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 12 }" prop="seqNo">
        <a-input-number v-model="form.seqNo" placeholder='顺序号'/>
      </a-form-model-item>
      <a-form-model-item
          label='状态'
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 12 }" prop="state">
        <a-switch v-model="form.state" checked-children="启用" un-checked-children="禁用" />
      </a-form-model-item>
      <a-form-model-item
          label='描述'
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 12 }" prop="remark">
        <a-input v-model="form.remark" placeholder='字典描述'/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import qs from 'qs'

export default {
  name: 'DictItemEdit',
  props: ['dictId'],
  data () {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      mode: '',
      parent: null,
      form: {
        name: null,
        value: null,
        seqNo: null,
        state: true,
        remark: null
      },
      rules: {
        name: [{ required: true, message: '请填写字典项名称' }],
        value: [{ required: true, message: '请填写字典项取值' }],
        seqNo: [{ required: true, message: '请填写数字类型顺序号' }]
      }
    }
  },
  methods: {
    preAdd: function (parentId) {
      this.resetFrom()
      const that = this
      this.title = '添加字典项'
      this.mode = 'add'
      this.visible = true
      if (parentId != null) {
        that.$http.get('/api/1/dict/dict-item.json?id=' + parentId).then(function (response) {
          that.parent = response.result
        })
      } else {
        that.parent = null
      }
    },
    preEdit: function (id) {
      this.resetFrom()
      const that = this
      this.title = '修改字典项'
      this.mode = 'edit'
      this.form.id = id
      this.visible = true
      that.$http.get('/api/1/dict/dict-item.json?id=' + id).then(function (resp) {
        that.form = resp.result
        that.form.state = resp.result.state === 'E'
        if (that.form.parentId != null) {
          that.$http.get('/api/1/dict/dict-item.json?id=' + that.form.parentId).then(function (response) {
            that.parent = response.result
          })
        } else {
          that.parent = null
        }
      })
    },
    resetFrom: function () {
      this.form = {
        name: null,
        value: null,
        seqNo: null,
        state: true,
        remark: null
      }
    },
    onSave: function () {
      const that = this
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        // action url
        let actionUrl = null
        // post params
        //
        if (that.mode === 'add') {
          actionUrl = '/api/1/dict/item-add.json'
        } else if (that.mode === 'edit') {
          actionUrl = '/api/1/dict/item-edit.json'
        }
        // post data
        this.form.dictId = that.dictId
        if (that.parent !== null) {
          this.form.parentId = that.parent.id
        }
        this.form.state = this.form.state ? 'E' : 'D'
        that.$http.post(actionUrl, qs.stringify(this.form)).then(function (resp) {
          that.visible = false
          that.confirmLoading = false
          that.$message.success('操作成功')
          that.$emit('success', resp.result.parentId)
        })
      })
    },
    onCancel: function () {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
